export const DATE_FILTER_LIST = [
  {
    name: "Last Week",
    id: "lastWeek",
    value: "lastWeek",
    title: "Last Week"
  },
  {
    name: "Yesterday",
    id: "filterYesterdayDate",
    value: "yesterday",
    title: "Yesterday"
  },
  {
    name: "Today",
    id: "filterTodayDate",
    value: "today",
    title: "Today"
  },
  {
    name: "This Month",
    id: "thisMonth",
    value: "thisMonth",
    title: "This Month"
  },
  {
    name: "7D",
    id: "7d",
    value: "7d",
    title: "7 Days"
  },
  {
    name: "30D",
    id: "30d",
    value: "30d",
    title: "30 Days"
  },
  {
    name: "Custom",
    id: "customDateFilter",
    value: "custom",
    title: "Custom"
  }
];
